module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"新闻动态":"News","视频中心":"Video Center","新闻中心":"News Center"},"zh":{"新闻动态":"新闻动态","视频中心":"视频中心","新闻中心":"新闻中心"}}')
  delete Component.options._Ctor
}
